import aiAssistantService from '@/services/ai-assistant.service'
import type { AIAssistantQuestionType } from '@/types/ai-assistant'

import { AIAssistantActionTypes } from './action_types'
import { AIAssistantMutationTypes } from './mutation_types'

import type { Commit } from 'vuex'

export const actions = {
  async [AIAssistantActionTypes.GET_CONVERSATIONS] (
    { commit }: { commit: Commit },
  ) {
    try {
      commit(AIAssistantMutationTypes.SET_CONVERSATIONS_PENDING, true)
      const response = await aiAssistantService.getConversations()
      commit(AIAssistantMutationTypes.SET_CONVERSATIONS, response.data)
      return response.data
    } finally {
      commit(AIAssistantMutationTypes.SET_CONVERSATIONS_PENDING, false)
    }
  },
  async [AIAssistantActionTypes.GET_CONVERSATION_MESSAGES] (
    { commit }: { commit: Commit },
    conversationId: string,
  ) {
    try {
      commit(AIAssistantMutationTypes.SET_CONVERSATION_MESSAGES_PENDING, true)
      const response = await aiAssistantService.getConversationMessages(conversationId)
      return response.data
    } finally {
      commit(AIAssistantMutationTypes.SET_CONVERSATION_MESSAGES_PENDING, false)
    }
  },
  async [AIAssistantActionTypes.POST_PROMPT] (
    { commit }: { commit: Commit },
    {
      mnemo,
      prompt,
      conversationId = null,
      questionType = null,
    }: {
      mnemo: string
      prompt: string
      conversationId?: string | null
      questionType?: AIAssistantQuestionType | null
    },
  ) {
    try {
      commit(AIAssistantMutationTypes.SET_POST_PROMPT_PENDING, true)
      const response = await aiAssistantService.postPrompt(mnemo, prompt, conversationId, questionType)
      return response.data
    } finally {
      commit(AIAssistantMutationTypes.SET_POST_PROMPT_PENDING, false)
    }
  },

  async [AIAssistantActionTypes.POST_STREAMED_PROMPT] (
    { commit }: { commit: Commit },
    {
      mnemo,
      prompt,
      conversationId = null,
      questionType = null,
      messageId = null,
      retry = false,
    }: {
      mnemo: string
      prompt: string
      conversationId?: string | null
      questionType?: AIAssistantQuestionType | null
      messageId?: string | null
      retry?: boolean
    },
  ) {
    commit(AIAssistantMutationTypes.SET_POST_PROMPT_STREAMING, true)
    return await aiAssistantService.postStreamedPrompt(
      mnemo,
      prompt,
      conversationId,
      questionType,
      messageId,
      retry,
    )
  },

  async [AIAssistantActionTypes.POST_STREAMED_DOC_PROMPT] (
    { commit }: { commit: Commit },
    {
      mnemo,
      prompt,
      conversationId = null,
      fileIds = [],
    }: {
      mnemo: string
      prompt: string
      conversationId?: string | null
      fileIds?: number[]
    },
  ) {
    commit(AIAssistantMutationTypes.SET_POST_PROMPT_STREAMING, true)
    return await aiAssistantService.postStreamedDocPrompt(
      mnemo,
      prompt,
      conversationId,
      fileIds,
    )
  },
}
